import React from "react";
import { Container, Row, Col } from "shards-react";

import MainNavbar from "../components/layout/MainNavbar/MainNavbar";
import MainSidebar from "../components/layout/MainSidebar/MainSidebar";
import MainFooter from "../components/layout/MainFooter";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getAllGrades } from "../redux/actions/grade-actions";
import { getAllSkills } from "../redux/actions/skill-actions";
import { getAllSkillGroups } from "../redux/actions/skill-groups-actions";
import { getAllSubjects } from "../redux/actions/subject-actions";
import { getAllQuestionTypes } from "../redux/actions/questionType-actions";
import { getCommonCoreIndependent } from "../redux/actions/common-core-independent-actions";

class ExternalCreatorDashboard extends React.Component {
  constructor(props) {
    super(props);
    // retrieve data
    this.props.getGrades();
    this.props.getSkills();
    this.props.getSkillGroups();
    this.props.getSubjects();
    this.props.getQuestionTypes();
    this.props.getCommonCoreIndependent();
  }

  render() {
    const children = React.Children.map(this.props.children, child => {
      return React.cloneElement(child, { ...this.props });
    });

    return (
      <Container fluid>
        <Row>
          <MainSidebar sidebarType={"externalCreator"} />
          <Col
            className="main-content p-0"
            lg={{ size: 10, offset: 2 }}
            md={{ size: 9, offset: 3 }}
            sm="12"
            tag="main"
          >
            {<MainNavbar />}
            {children}
            {!this.props.noFooter && <MainFooter />}
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return {
    grades: state.grades,
    skills: state.skills,
    skillGroups: state.skillGroups,
    questionTypes: state.questionTypes,
    userData: state.userData
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getGrades: bindActionCreators(getAllGrades, dispatch),
    getSkills: bindActionCreators(getAllSkills, dispatch),
    getSkillsGroups: bindActionCreators(getAllSkillGroups, dispatch),
    getSubjects: bindActionCreators(getAllSubjects, dispatch),
    getQuestionTypes: bindActionCreators(getAllQuestionTypes, dispatch),
    getCommonCoreIndependent: bindActionCreators(getCommonCoreIndependent, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExternalCreatorDashboard);
